import { render, staticRenderFns } from "./BallotsCell.vue?vue&type=template&id=cc4aabc6&"
import script from "./BallotsCell.vue?vue&type=script&lang=js&"
export * from "./BallotsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports